import { Command } from 'cmdk';
import styled from 'styled-components';

import { theme } from '../../ui/theme';

export const CommandDialog = styled(Command.Dialog)`
    max-width: 640px;
    width: 100%;
    border-radius: ${theme.radii[8]};
    overflow: hidden;
    padding: 0;
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    background: ${theme.colors.background.default};

    z-index: ${theme.zIndex.shortcutMenu};
    box-shadow:
        0px 0px 0px 1px #f1f7fa,
        0px 120px 120px 0px rgba(25, 54, 67, 0.08),
        0px 64px 64px 0px rgba(25, 54, 67, 0.12),
        0px 32px 32px 0px rgba(25, 54, 67, 0.04),
        0px 24px 24px 0px rgba(25, 54, 67, 0.04),
        0px 4px 24px 0px rgba(25, 54, 67, 0.04),
        0px 4px 4px 0px rgba(25, 54, 67, 0.04);

    [cmdk-list] {
        min-height: 300px;
        max-height: 500px;
        overflow: auto;
        overscroll-behavior: contain;
        transition: 100ms ease;
        transition-property: height;
        padding-bottom: ${theme.space[4]};
    }

    [cmdk-group-heading] {
        user-select: none;
        font-size: ${theme.fontSizes[12]};
        color: ${theme.colors.foreground.muted};
        padding: ${theme.space[8]} 0;
        margin: 0 ${theme.space[4]};
        display: flex;
        align-items: center;
    }

    [cmdk-separator] {
        height: 1px;
        background: ${theme.colors.border.subtle};
        margin: ${theme.space[4]} ${theme.space[4]};
    }
`;
